import { useState } from 'react';

import PublicHttpClient from '../../shared/infrastructures/clients/public-http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { PUBLIC_AUTHENTICATION_API_PATHS } from '../constants/authentication-paths.constants';
import { ResetPasswordRequestDTO } from '../types/authentication.dto';

const FALLBACK_MESSAGE = 'La réinitialisation a échoué';

type UseResetPasswordResult = {
  isSubmitting: boolean;
  error: string | null;
  submit: (payload: ResetPasswordRequestDTO) => Promise<boolean>;
};

export function useResetPassword(): UseResetPasswordResult {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (payload: ResetPasswordRequestDTO): Promise<boolean> => {
    setIsSubmitting(true);
    setError(null);

    try {
      await PublicHttpClient.post<void, ResetPasswordRequestDTO>(
        PUBLIC_AUTHENTICATION_API_PATHS.RESET_PASSWORD,
        payload
      );

      return true;
    } catch (caught) {
      setError(extractApiErrorMessage(caught, FALLBACK_MESSAGE));

      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, error, submit };
}
